module.exports = __webpack_public_path__ + "static/media/599.7554(12).2151f22a.pdf";